import Vue from 'vue'
import Router from 'vue-router'

const JumpPage = () => import('@/pages/JumpPage')
const Login = () => import('@/pages/Login')
const Page404 = () => import('@/pages/Page404')
const StudentMain = () => import('@/pages/student/studentMain')
const ExamMain = () => import('@/pages/exam/ExamMain')
const Exam = () => import('@/pages/exam/Exam')
const ExamOutcomeMain = () => import('@/pages/examOutcome/ExamOutcomeMain')
const ShopMapMain = () => import('@/pages/shopMap/ShopMapMain')
const AdministrationMain = () => import('@/pages/administration/AdministrationMain')
const admincontrolMain = () => import('@/pages/administration/admincontrolMain')
const authorize = () => import('@/pages/administration/authorize')
const studentNumberList = () => import('@/pages/administration/studentNumberList')
const studentList = () => import('@/pages/administration/studentList')
Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/jumpPage'
    },
    {
      path: '/jumpPage',
      name: '跳转页',
      component: JumpPage,
      meta: {
        title: '跳转页'
      }
    },
    {
      path: '/login',
      name: '登录',
      component: Login,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/studentMain',
      name: 'StudentMain',
      component: StudentMain,
      meta: {
        title: '会员一览'
      }
    },
    {
      path: '/examMain',
      name: 'ExamMain',
      component: ExamMain,
      meta: {
        title: '定期考试'
      }
    },
    {
      path: '/exam',
      name: 'Exam',
      component: Exam,
      meta: {
        title: '会员考试'
      }
    },
    {
      path: '/examOutcomeMain',
      name: 'ExamOutcomeMain',
      component: ExamOutcomeMain,
      meta: {
        title: '考试结果'
      }
    },
    {
      path: '/shopMapMain',
      name: 'ShopMapMain',
      component: ShopMapMain,
      meta: {
        title: '地图查询'
      }
    },
    {
      path: '/administrationMain',
      name: 'AdministrationMain',
      component: AdministrationMain,
      meta: {
        title: '管理一览'
      }
    },
    {
      path: '/admincontrolMain',
      name: 'admincontrolMain',
      component: admincontrolMain,
      meta: {
        title: '总控'
      }
    },
    {
      path: '/authorize',
      name: 'authorize',
      component: authorize,
      meta: {
        title: '管理权限申请'
      }
    },
    {
      path: '/studentNumberList',
      name: 'studentNumberList',
      component: studentNumberList,
      meta: {
        title: '编号一览'
      }
    },
    {
      path: '/studentList',
      name: 'studentList',
      component: studentList,
      meta: {
        title: '编号一览'
      }
    },
    {
      path: '*',
      component: Page404,
      hidden: true
    }
  ]
})

router.beforeEach((to, from, next) => {
  // 路由发生改变修改页面的 title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js